import { useSelector } from 'react-redux'

import { getFormattedAmount } from 'primsell-shared-layer/helpers'
import { currencyRatesSelector, selectedCurrencySelector } from 'primsell-shared-layer/features'

import { CurrencyPairValueT, IFiatCryptoDisplayProps } from 'primsell-shared-layer/types'

export enum FiatCurrenciesE {
  EUR = 'EUR',
  CAD = 'CAD',
}

export interface ICurrencyConversionProps {
  value: number | string | null | undefined
  fromCurrency: FiatCurrenciesE | null
  toCurrency: FiatCurrenciesE | null
  currencyRates: CurrencyPairValueT
}

export const convertCurrency = ({
  value,
  fromCurrency,
  toCurrency,
  currencyRates,
}: ICurrencyConversionProps): number => {
  const amount = Number(value)

  if (fromCurrency === toCurrency) {
    return amount
  }

  const fromRateKey = `${fromCurrency}_${fromCurrency}` as keyof CurrencyPairValueT
  const toRateKey = `${toCurrency}_${toCurrency}` as keyof CurrencyPairValueT
  const crossRateKey = `${fromCurrency}_${toCurrency}` as keyof CurrencyPairValueT

  const fromRate = currencyRates[fromRateKey] ?? 1
  const toRate = currencyRates[toRateKey] ?? 1
  const directRate = currencyRates[crossRateKey]

  if (directRate !== undefined) {
    return amount * directRate
  }

  const baseCurrency = FiatCurrenciesE.EUR
  const amountInBase = fromCurrency === baseCurrency ? amount : amount / fromRate
  const convertedAmount = toCurrency === baseCurrency ? amountInBase : amountInBase * toRate

  return convertedAmount
}

const FiatCryptoDisplay = ({ value, currency, onlyDisplay = false }: IFiatCryptoDisplayProps) => {
  const selectedCurrency = useSelector(selectedCurrencySelector) //
  const currencyRates = useSelector(currencyRatesSelector)

  if (!currency || !currencyRates) {
    return '-'
  }

  if (onlyDisplay) {
    return `${getFormattedAmount(Number(value), currency)} ${currency}`
  }

  const convertedAmount = convertCurrency({
    value,
    fromCurrency: currency,
    toCurrency: selectedCurrency,
    currencyRates,
  })

  const formattedAmount = getFormattedAmount(Number(convertedAmount), currency)

  return `${formattedAmount} ${selectedCurrency}`
}

export { FiatCryptoDisplay }
